import {
  defaultState,
  DUPLICATE_CLIENTS_FAILURE,
  DUPLICATE_CLIENTS_REQUEST,
  DUPLICATE_CLIENTS_SUCCESS,
  MERGE_CLIENT_FAILURE,
  MERGE_CLIENT_REQUEST,
  MERGE_CLIENT_SUCCESS,
} from 'mergeClients/constants';

const mergeClientsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case DUPLICATE_CLIENTS_REQUEST: {
      return {
        ...state,
        loadingClientsData: true,
      };
    }
    case DUPLICATE_CLIENTS_SUCCESS: {
      const modClients = action.response.map((p) => ({ ...p, isMerged: false }));
      return {
        ...state,
        clientList: modClients,
        loadingClientsData: false,
      };
    }
    case DUPLICATE_CLIENTS_FAILURE:
      return {
        ...state,
        errorLoading: true,
      };
    case MERGE_CLIENT_REQUEST:
      return {
        ...state,
        isMerging: true,
      };
    case MERGE_CLIENT_SUCCESS: {
      let calcList = [...state.clientList];
      const mergedSet = new Set();
      // eslint-disable-next-line no-plusplus
      for (let i = 0, arr = action.params.duplicateClients; i < arr.length; i++) {
        mergedSet.add(arr[i].master_client);
      }

      calcList = calcList.map((client) =>
        mergedSet.has(client.id) ? { ...client, isMerged: true } : { ...client, show: false },
      );

      return {
        ...state,
        clientList: calcList,
        isMerging: false,
      };
    }
    case MERGE_CLIENT_FAILURE:
      return {
        ...state,
        isMerging: false,
      };
    default:
      return state;
  }
};

export default mergeClientsReducer;
